const lightColor = `#fff`;
const darkColor = `#1c1d1a`;
export const highlightColor = `#e30713`;
export const contentColor = darkColor;
export const contrastTextColor = lightColor;

export const contentColorDark = lightColor;
export const backgroundColorDark = darkColor;
export const backgroundColorLight = lightColor;
